import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

export const NoFundsAddedInfo: FC = () => {
  const texts = useTexts();

  return (
    <span className="font-body">
      {texts.orders.form.table.subscription.noFundsAdded}
    </span>
  );
};
